import { StandardEvents } from '@shopify/events';

/**
 * Eme Mater (14/09/2026): keeps the XB Wishlist buttons of snippets/eme-wishlist-button pointed at
 * the variant on screen. The XB script reads xb-product-variant at click time, and the theme only
 * morphs the add-to-cart button on a size change, so without this the favorite would save the size
 * that was selected when the page loaded.
 */
class EmeWishlist extends HTMLElement {
  #abortController = new AbortController();

  connectedCallback() {
    const scope = this.closest('.shopify-section') ?? document;
    scope.addEventListener(StandardEvents.productSelect, this.#handleProductSelect, {
      signal: this.#abortController.signal,
    });
  }

  disconnectedCallback() {
    this.#abortController.abort();
  }

  /**
   * @param {import('@shopify/events').ProductSelectEvent} event
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      ?.then(({ detail }) => {
        const variant = detail?.resource;
        if (!variant?.id) return;
        if (detail.productId && String(detail.productId) !== this.dataset.productId) return;

        for (const button of this.querySelectorAll('[xb-product-variant]')) {
          button.setAttribute('xb-product-variant', String(variant.id));
        }
      })
      .catch(() => {});
  };
}

if (!customElements.get('eme-wishlist')) {
  customElements.define('eme-wishlist', EmeWishlist);
}
